// eslint-disable-next-line max-classes-per-file
import { CreateEventRequest, UpdateEventRequest } from '@ftr/annotations-contracts/v2'
import { Uuid } from '@ftr/contracts/type/shared'

export class CreateHearingSectionEventCommand {
  static readonly type = '[HearingSectionEvents] Create'
  constructor(
    readonly courtSystemId: Uuid,
    readonly body: CreateEventRequest,
  ) {}
}

/**
 * A content (person/role) change to an appearance event. Surfaces an effect toast and refetches the
 * people annotations. Time-only changes are handled separately in the component via the save-status
 * indicator (they don't toast), so there is deliberately no time-update command here.
 */
export class UpdateHearingSectionEventContentCommand {
  static readonly type = '[HearingSectionEvents] Update Content'
  constructor(
    readonly courtSystemId: Uuid,
    readonly eventId: Uuid,
    readonly resources: NonNullable<UpdateEventRequest['resources']>,
    // recordingId triggers a people-annotations refetch when the update re-links an appearance.
    readonly recordingId: Uuid | undefined,
  ) {}
}

export class DeleteHearingSectionEventCommand {
  static readonly type = '[HearingSectionEvents] Delete'
  constructor(
    readonly courtSystemId: Uuid,
    readonly eventId: Uuid,
  ) {}
}

/** Dispatched after a successful create/update/delete so views can refresh their event markers. */
export class HearingSectionEventsChangedEvent {
  static readonly type = '[HearingSectionEvents] Changed'
}
